import { render, staticRenderFns } from "./icon4.vue?vue&type=template&id=b2c2b7b0&scoped=true&"
import script from "./icon4.vue?vue&type=script&lang=js&"
export * from "./icon4.vue?vue&type=script&lang=js&"
import style0 from "./icon4.vue?vue&type=style&index=0&id=b2c2b7b0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c2b7b0",
  null
  
)

export default component.exports